const dataProposeLayout = [
  {
    desc: "Green Tree Plantation (Lot 4)",
    NEcoord: [],
    coord: [
      { lng: 114.1337944857134, lat: 4.192947268812822 },
      { lng: 114.1927342487271, lat: 4.175059865576693 },
      { lng: 114.1923736042249, lat: 4.177453843487833 },
      { lng: 114.1924440668453, lat: 4.180238084053869 },
      { lng: 114.1928027279894, lat: 4.18284732337959 },
      { lng: 114.1937980818523, lat: 4.185318431417289 },
      { lng: 114.1944465483729, lat: 4.18724002763387 },
      { lng: 114.1939654276596, lat: 4.189140777424219 },
      { lng: 114.1926584053723, lat: 4.190547815095964 },
      { lng: 114.1935937614531, lat: 4.193688633736784 },
      { lng: 114.1955532264407, lat: 4.196276189279168 },
      { lng: 114.1980250143236, lat: 4.19923498873442 },
      { lng: 114.2008087821038, lat: 4.201847501055974 },
      { lng: 114.2008994732854, lat: 4.205290658935811 },
      { lng: 114.2003058740514, lat: 4.208367271134085 },
      { lng: 114.2002237716819, lat: 4.21114000229527 },
      { lng: 114.201099193392, lat: 4.213714844866883 },
      { lng: 114.2017564945569, lat: 4.215207177784848 },
      { lng: 114.2020577056982, lat: 4.216514350252059 },
      { lng: 114.197241559241, lat: 4.215318980436786 },
      { lng: 114.1937469363425, lat: 4.215137416853251 },
      { lng: 114.1874922007257, lat: 4.213290612041673 },
      { lng: 114.1842936587225, lat: 4.213288367317687 },
      { lng: 114.165303438074, lat: 4.206481841414548 },
      { lng: 114.1606521882668, lat: 4.203694229814164 },
      { lng: 114.1536995687757, lat: 4.201692139657353 },
      { lng: 114.1480494850445, lat: 4.201358943783204 },
      { lng: 114.1435478958826, lat: 4.200348008114125 },
      { lng: 114.1374984956713, lat: 4.197125257902918 },
      { lng: 114.1337944857134, lat: 4.192947268812822 },  
    ],
  },
  {
    desc: "Green Tree Plantation (Lot 5)",
    NEcoord: [],
    coord: [
      { lng: 114.1060727198639, lat: 4.163777381885949 },
      { lng: 114.1001784763157, lat: 4.15463364304551 },
      { lng: 114.0957654309073, lat: 4.15227266193654 },
      { lng: 114.0954429011424, lat: 4.147874923411186 },
      { lng: 114.0972804102031, lat: 4.142478057721514 },
      { lng: 114.0975534003801, lat: 4.138886595095491 },
      { lng: 114.1046819352573, lat: 4.125221546754266 },
      { lng: 114.1070630410079, lat: 4.118471597838153 },
      { lng: 114.1083250070372, lat: 4.108977803935679 },
      { lng: 114.1073925070714, lat: 4.100123416522488 },
      { lng: 114.1073013467555, lat: 4.090595777575971 },
      { lng: 114.1044191520823, lat: 4.08252219762058 },
      { lng: 114.104657904675, lat: 4.076775414953802 },    //_ bottom left
      { lng: 114.1461152447005, lat: 4.076908093995915 },   //_ bottom right
      { lng: 114.1425039534118, lat: 4.080234837268259 },
      { lng: 114.1446291377691, lat: 4.08435062428695 },
      { lng: 114.1475238190019, lat: 4.087711811069901 },
      { lng: 114.152258895004, lat: 4.091535171870737 },
      { lng: 114.1550116321332, lat: 4.09337087580633 },
      { lng: 114.1510335389946, lat: 4.096746347964398 },
      { lng: 114.1494994053895, lat: 4.100893995860437 },
      { lng: 114.1491908186706, lat: 4.103355569810957 },
      { lng: 114.1455835699221, lat: 4.103142719693171 },
      { lng: 114.1411767413012, lat: 4.106462927752369 },
      { lng: 114.1426832591313, lat: 4.111298804988283 },
      { lng: 114.1451070637684, lat: 4.115842583743901 },
      { lng: 114.1467760369003, lat: 4.119180514229481 },
      { lng: 114.1484462472494, lat: 4.123740214865894 },
      { lng: 114.1495115728529, lat: 4.125415164477277 },
      { lng: 114.1534763668745, lat: 4.126484559002942 },
      { lng: 114.155764953265, lat: 4.126637520219496 },
      { lng: 114.1553084260037, lat: 4.128772104191378 },
      { lng: 114.1542406325945, lat: 4.131213521389859 },
      { lng: 114.1551586380204, lat: 4.1345753073 },
      { lng: 114.1576055431186, lat: 4.136105321591825 },
      { lng: 114.1602040548805, lat: 4.136104357517279 },
      { lng: 114.1631064074793, lat: 4.135491163243075 },
      { lng: 114.1667705621135, lat: 4.134267780225351 },
      { lng: 114.1678323797122, lat: 4.130757750789091 },
      { lng: 114.1670583083253, lat: 4.127249078828393 },
      { lng: 114.1675110031617, lat: 4.125572933017155 },
      { lng: 114.1690366290578, lat: 4.1255731074329 },
      { lng: 114.1695022883993, lat: 4.12785920348272 },
      { lng: 114.1710401611456, lat: 4.130910771994354 },
      { lng: 114.1733493374095, lat: 4.135037108403686 },
      { lng: 114.1748897271093, lat: 4.137790834752646 },
      { lng: 114.1733681992892, lat: 4.140391311539326 },
      { lng: 114.1724626437289, lat: 4.1431527740418 },
      { lng: 114.1739916394152, lat: 4.144618719116524 },
      { lng: 114.1759775228633, lat: 4.146284400200504 },
      { lng: 114.1776598092296, lat: 4.147799862149606 },
      { lng: 114.1772135707157, lat: 4.149619755020676 },
      { lng: 114.1760111096549, lat: 4.152504274340258 },
      { lng: 114.1755662627812, lat: 4.15478428216975 },
      { lng: 114.1775612782464, lat: 4.15706719792459 },
      { lng: 114.1816953138149, lat: 4.159353220032227 },
      { lng: 114.1830766245114, lat: 4.160420833730831 },
      { lng: 114.1832432106324, lat: 4.162252101679473 },
      { lng: 114.1815898498124, lat: 4.165919242285079 },
      { lng: 114.1808432227862, lat: 4.168368028876567 },
      { lng: 114.1810149529155, lat: 4.170820912747735 },
      { lng: 114.1825632510392, lat: 4.172818068758598 },
      { lng: 114.1854890532274, lat: 4.174204619004539 },
      { lng: 114.1888576597746, lat: 4.173440603798946 },
      { lng: 114.1917350829419, lat: 4.169759330270407 },
      { lng: 114.1927994764042, lat: 4.169450809471078 },
      { lng: 114.1931273167049, lat: 4.17159818521148 },
      { lng: 114.1925468903378, lat: 4.174365168908986 },
      { lng: 114.1333489467108, lat: 4.193018659620925 },
      { lng: 114.130179647197, lat: 4.186791196031941 },
      { lng: 114.1255039343396, lat: 4.179673209006123 },
      { lng: 114.120081711155, lat: 4.173483632715186 },
      { lng: 114.115720680227, lat: 4.169419113807232 },
      { lng: 114.1098360287885, lat: 4.166863080176957 },
      { lng: 114.1060727198639, lat: 4.163777381885949 },      
    ],
  },
  {
    desc: "Grand Olie Sdn Bhd",
    NEcoord: [],
    coord: [
      { lng: 114.1450973699495, lat: 4.060095708774473 },
      { lng: 114.1452262341289, lat: 4.061042835346991 },
      { lng: 114.1459551706471, lat: 4.06191649906443 },
      { lng: 114.1469970317303, lat: 4.065844923429134 },
      { lng: 114.1472706582403, lat: 4.066479757127251 },
      { lng: 114.147846155854, lat: 4.06871033452867 },
      { lng: 114.1483611041922, lat: 4.070754569254341 },
      { lng: 114.1491999909883, lat: 4.072401317704591 },
      { lng: 114.1497776622215, lat: 4.073633034916234 },
      { lng: 114.1504759404102, lat: 4.074137530013906 },
      { lng: 114.1515388945261, lat: 4.074034292695065 },
      { lng: 114.1525332292781, lat: 4.073426482865419 },
      { lng: 114.1536546968335, lat: 4.074076514808507 },
      { lng: 114.1540587523332, lat: 4.074623493275906 },
      { lng: 114.1543811931514, lat: 4.075566153621654 },
      { lng: 114.1541315228643, lat: 4.07669752477117 },
      { lng: 114.1032422676166, lat: 4.076641235590489 },
      { lng: 114.1028441863958, lat: 4.071342566332274 },
      { lng: 114.102566916614, lat: 4.065547314948979 },
      { lng: 114.1028528138228, lat: 4.064103511154921 },
      { lng: 114.1045922392497, lat: 4.063569644476823 },
      { lng: 114.1045268024367, lat: 4.060552084054558 },
      { lng: 114.106022979059, lat: 4.057412236025591 },
      { lng: 114.1071866662325, lat: 4.045431976345557 },
      { lng: 114.1086916433147, lat: 4.036517239532756 },
      { lng: 114.1084859081644, lat: 4.032525046528792 },
      { lng: 114.1086287643051, lat: 4.030847932036018 },
      { lng: 114.1107316686886, lat: 4.029197740015887 },
      { lng: 114.1110764709044, lat: 4.023592714757005 },
      { lng: 114.1106069488764, lat: 4.022575693987844 },
      { lng: 114.1111139821802, lat: 4.022157470256947 },
      { lng: 114.1090519718961, lat: 4.020231130394985 },
      { lng: 114.1093683694374, lat: 4.018957525669816 },
      { lng: 114.1098115335973, lat: 4.009616267152979 },
      { lng: 114.1104757651206, lat: 4.001516251949506 },
      { lng: 114.1236493873156, lat: 4.001354255751481 },
      { lng: 114.1488978785801, lat: 3.999136599085181 },
      { lng: 114.1504104074879, lat: 3.983696255798159 },
      { lng: 114.1557175310159, lat: 3.980158505837605 },
      { lng: 114.1586879390684, lat: 3.976213683195681 },
      { lng: 114.1572865451173, lat: 3.971015284933788 },
      { lng: 114.1549837868765, lat: 3.968231593936368 },
      { lng: 114.1581865485563, lat: 3.967274240254943 },
      { lng: 114.1616148321558, lat: 3.96283011275484 },
      { lng: 114.1636893134037, lat: 3.960394244749019 },
      { lng: 114.1663577530189, lat: 3.95548081436448 },
      { lng: 114.1688888975841, lat: 3.95170574386202 },
      { lng: 114.1723837097586, lat: 3.948379440959224 },
      { lng: 114.1736528209252, lat: 3.947690201068109 },
      { lng: 114.1765614357193, lat: 3.946911639522794 },
      { lng: 114.1785925375986, lat: 3.946338968239538 },
      { lng: 114.1798619847469, lat: 3.945576343723344 },
      { lng: 114.1807914071349, lat: 3.944215425895103 },
      { lng: 114.1815725163108, lat: 3.943610595595266 },
      { lng: 114.1821947308818, lat: 3.941962561947563 },
      { lng: 114.1835760435531, lat: 3.940708274302049 },
      { lng: 114.1842108738385, lat: 3.939258668458046 },
      { lng: 114.1844083429499, lat: 3.938395369932152 },
      { lng: 114.1850836239583, lat: 3.937415734010703 },
      { lng: 114.1857821978539, lat: 3.936520956571477 },
      { lng: 114.1867919128123, lat: 3.935420286675942 },
      { lng: 114.1870810247763, lat: 3.934190132883703 },
      { lng: 114.1882995231781, lat: 3.934278284178929 },
      { lng: 114.1886831459778, lat: 3.933740020892754 },
      { lng: 114.1896004914352, lat: 3.931171590161462 },
      { lng: 114.190506821554, lat: 3.929975354670394 },
      { lng: 114.1909520119116, lat: 3.92580809093361 },
      { lng: 114.1916159827565, lat: 3.92456646335653 },
      { lng: 114.191952455201, lat: 3.922177591074199 },
      { lng: 114.192588984752, lat: 3.920940109482369 },
      { lng: 114.1930771579022, lat: 3.920145487009071 },
      { lng: 114.1933601587221, lat: 3.918788110399491 },
      { lng: 114.1911063950836, lat: 3.916304274991575 },
      { lng: 114.1887055572399, lat: 3.913193316003402 },
      { lng: 114.1878282090594, lat: 3.910899205300431 },
      { lng: 114.1868469081526, lat: 3.909662760291222 },
      { lng: 114.1860992243849, lat: 3.906749981192025 },
      { lng: 114.1841697149619, lat: 3.905019941219371 },
      { lng: 114.1833946039817, lat: 3.903679969395859 },
      { lng: 114.183444750147, lat: 3.902156199065755 },
      { lng: 114.1824195645607, lat: 3.900262311601277 },
      { lng: 114.182348048424, lat: 3.899192920294266 },
      { lng: 114.1820888705163, lat: 3.898315001335901 },
      { lng: 114.1828911785474, lat: 3.896505625458331 },
      { lng: 114.1831918618907, lat: 3.895140471240478 },
      { lng: 114.1840539643935, lat: 3.893843314962973 },
      { lng: 114.1847575481035, lat: 3.890108441680529 },
      { lng: 114.1873414185591, lat: 3.888588239963585 },
      { lng: 114.1899440083026, lat: 3.889384965847416 },
      { lng: 114.1920165084009, lat: 3.88786972513785 },
      { lng: 114.1940602688416, lat: 3.884207916887322 },
      { lng: 114.200851235728, lat: 3.879039026482373 },
      { lng: 114.2049973764358, lat: 3.875802808879414 },
      { lng: 114.2056815190452, lat: 3.873284164107922 },
      { lng: 114.2112893666541, lat: 3.867812703839773 },
      { lng: 114.2127004132494, lat: 3.865931748795931 },
      { lng: 114.2155604066854, lat: 3.860301220531436 },
      { lng: 114.2337115779326, lat: 3.850273635462697 },
      { lng: 114.2351182243164, lat: 3.850273967684543 },
      { lng: 114.2352988670672, lat: 3.854858215596279 },
      { lng: 114.236581521288, lat: 3.863954330250349 },
      { lng: 114.237357764476, lat: 3.869237088879754 },
      { lng: 114.238968945544, lat: 3.879649630160985 },
      { lng: 114.2527146943595, lat: 3.897061720492621 },
      { lng: 114.2479711021311, lat: 3.898926744204351 },
      { lng: 114.2439174163944, lat: 3.903029547607085 },
      { lng: 114.2429062348453, lat: 3.907798400477649 },
      { lng: 114.24254993539, lat: 3.912502089066595 },
      { lng: 114.2403303546253, lat: 3.914818385312712 },
      { lng: 114.2391542839658, lat: 3.917453880090923 },
      { lng: 114.2393619026234, lat: 3.920692405107261 },
      { lng: 114.2393292087563, lat: 3.923230710730994 },
      { lng: 114.2384428059507, lat: 3.924557279870424 },
      { lng: 114.2363188736442, lat: 3.925949016698074 },
      { lng: 114.2339895221673, lat: 3.927370267233477 },
      { lng: 114.2329896925296, lat: 3.92780620067806 },
      { lng: 114.2314013144789, lat: 3.930129231126658 },
      { lng: 114.230966092163, lat: 3.933114551664732 },
      { lng: 114.2320320331885, lat: 3.942720092115016 },
      { lng: 114.2324188592024, lat: 3.94321583721946 },
      { lng: 114.2323337522282, lat: 3.945151271179222 },
      { lng: 114.2328195426257, lat: 3.946219812993728 },
      { lng: 114.2378255734552, lat: 3.949734100462087 },
      { lng: 114.2393540133441, lat: 3.95055537860585 },
      { lng: 114.2396691362672, lat: 3.951498282918466 },
      { lng: 114.2394837245475, lat: 3.952618800895506 },
      { lng: 114.2381228252493, lat: 3.953669218370988 },
      { lng: 114.2377002030372, lat: 3.953561498345097 },
      { lng: 114.2342723486535, lat: 3.953301223004391 },
      { lng: 114.2323105583735, lat: 3.954270402347319 },
      { lng: 114.2304671054813, lat: 3.954577445203773 },
      { lng: 114.2290491924703, lat: 3.956897499396374 },
      { lng: 114.2293305541492, lat: 3.958314822243946 },
      { lng: 114.2321072971397, lat: 3.962193291329976 },
      { lng: 114.2320188642307, lat: 3.963594639730264 },
      { lng: 114.231351623352, lat: 3.964742612589582 },
      { lng: 114.2299183080404, lat: 3.965904882820162 },
      { lng: 114.2281413682588, lat: 3.967304702727204 },
      { lng: 114.2269537586973, lat: 3.967338722883477 },
      { lng: 114.2256026722492, lat: 3.966419433511897 },
      { lng: 114.2238002391101, lat: 3.966497754003764 },
      { lng: 114.2218110293142, lat: 3.965899165043122 },
      { lng: 114.2199698977993, lat: 3.966511343253902 },
      { lng: 114.2193908619544, lat: 3.967295049153589 },
      { lng: 114.2195632076351, lat: 3.968399816441932 },
      { lng: 114.2200527175485, lat: 3.969242905145371 },
      { lng: 114.2206875560015, lat: 3.970872895439467 },
      { lng: 114.2211965908138, lat: 3.971619237113779 },
      { lng: 114.2222474296937, lat: 3.972932420363821 },
      { lng: 114.2237194853376, lat: 3.974462778539791 },
      { lng: 114.2245520811447, lat: 3.975574694747673 },
      { lng: 114.2250906634621, lat: 3.976306127030972 },
      { lng: 114.2247645730575, lat: 3.977587731723801 },
      { lng: 114.223753776025, lat: 3.977806488235122 },
      { lng: 114.2226750735795, lat: 3.977709777338001 },
      { lng: 114.2209685493986, lat: 3.978512620926785 },
      { lng: 114.2180632990148, lat: 3.978365542028825 },
      { lng: 114.2162259920706, lat: 3.977727896073378 },
      { lng: 114.2147919001449, lat: 3.97741849682434 },
      { lng: 114.2132008894739, lat: 3.977470460034156 },
      { lng: 114.2115656521652, lat: 3.977490682801131 },
      { lng: 114.2104039755492, lat: 3.977794666094952 },
      { lng: 114.2096370466339, lat: 3.978012819626333 },
      { lng: 114.2087854345575, lat: 3.978833876704642 },
      { lng: 114.2075143323232, lat: 3.97887872688192 },
      { lng: 114.2068826385873, lat: 3.976226763062127 },
      { lng: 114.2058481698038, lat: 3.975563258309527 },
      { lng: 114.2053425537577, lat: 3.975117569235247 },
      { lng: 114.2046364368249, lat: 3.975314487898932 },
      { lng: 114.2037813771089, lat: 3.97544841910976 },
      { lng: 114.2020011791203, lat: 3.976517004593104 },
      { lng: 114.201274725168, lat: 3.977184833223745 },
      { lng: 114.200917897103, lat: 3.977747880793793 },
      { lng: 114.1998303025338, lat: 3.978254093063976 },
      { lng: 114.198639512511, lat: 3.979702769576511 },
      { lng: 114.1975481291298, lat: 3.981506174114531 },
      { lng: 114.1968312285542, lat: 3.982429804457139 },
      { lng: 114.1966661016881, lat: 3.982936397118341 },
      { lng: 114.1960734721959, lat: 3.984181779833207 },
      { lng: 114.1955615184243, lat: 3.985804425480423 },
      { lng: 114.1956974127084, lat: 3.986941125371725 },
      { lng: 114.1955606080159, lat: 3.987983655659648 },
      { lng: 114.1960582475975, lat: 3.989225466111808 },
      { lng: 114.1960322679747, lat: 3.990604913030559 },
      { lng: 114.1961163762353, lat: 3.991017373647592 },
      { lng: 114.1957351658159, lat: 3.991576318726405 },
      { lng: 114.1947261117502, lat: 3.991830153791645 },
      { lng: 114.1935102913377, lat: 3.991516173117564 },
      { lng: 114.192722231833, lat: 3.990355439438299 },
      { lng: 114.1920793784485, lat: 3.989888747318163 },
      { lng: 114.1919750279402, lat: 3.988641821853826 },
      { lng: 114.1923721519761, lat: 3.987466961475387 },
      { lng: 114.1924003163966, lat: 3.986256937449118 },
      { lng: 114.1927698890725, lat: 3.985600908967857 },
      { lng: 114.1925874262268, lat: 3.984833529224249 },
      { lng: 114.1917111463802, lat: 3.98406320882162 },
      { lng: 114.1905234012138, lat: 3.983660632089901 },
      { lng: 114.189634913128, lat: 3.98324594694858 },
      { lng: 114.1889109032894, lat: 3.983344988188898 },
      { lng: 114.1873705884984, lat: 3.984557761618917 },
      { lng: 114.1872023376693, lat: 3.985594246387159 },
      { lng: 114.1869394429909, lat: 3.986468240110298 },
      { lng: 114.1864275078916, lat: 3.987279549494168 },
      { lng: 114.1848397033308, lat: 3.990998759840584 },
      { lng: 114.1848300624835, lat: 3.992293107278292 },
      { lng: 114.1843073998292, lat: 3.993385694016577 },
      { lng: 114.183918630393, lat: 3.99620778916076 },
      { lng: 114.183564982175, lat: 3.997622401189805 },
      { lng: 114.1834292649657, lat: 4.000574602011243 },
      { lng: 114.1830145261747, lat: 4.001588298929575 },
      { lng: 114.1830159587749, lat: 4.002577380416085 },
      { lng: 114.1826367606827, lat: 4.003205292427984 },
      { lng: 114.1819055606238, lat: 4.003365322859303 },
      { lng: 114.1807123516417, lat: 4.002902235864383 },
      { lng: 114.1794157642937, lat: 4.001684943754798 },
      { lng: 114.1792237431573, lat: 4.000190646678069 },
      { lng: 114.1799127003041, lat: 3.99781423844633 },
      { lng: 114.1796630720845, lat: 3.996507995393197 },
      { lng: 114.1798453917128, lat: 3.994751237846873 },
      { lng: 114.1805030996663, lat: 3.992960816905904 },
      { lng: 114.1804869704659, lat: 3.99196638061467 },
      { lng: 114.179510839846, lat: 3.991102242862343 },
      { lng: 114.1782421556883, lat: 3.990926125704419 },
      { lng: 114.1769782088247, lat: 3.991619082868851 },
      { lng: 114.1758298427907, lat: 3.992464992068082 },
      { lng: 114.1755694490135, lat: 3.993056635110378 },
      { lng: 114.1756426886443, lat: 3.99519942574771 },
      { lng: 114.1753817428858, lat: 3.996080504451548 },
      { lng: 114.175388931024, lat: 3.997116360288907 },
      { lng: 114.1751528759433, lat: 3.997659489667007 },
      { lng: 114.1753154205073, lat: 4.000442521004213 },
      { lng: 114.1753333228573, lat: 4.00160449848782 },
      { lng: 114.1752850418988, lat: 4.002383157770209 },
      { lng: 114.1754463003972, lat: 4.002958886076871 },
      { lng: 114.175358819125, lat: 4.003891225286114 },
      { lng: 114.1748523606257, lat: 4.004662982340352 },
      { lng: 114.1743054364763, lat: 4.004764569330406 },
      { lng: 114.1733692791387, lat: 4.005620447514282 },
      { lng: 114.1726711228459, lat: 4.005886239115687 },
      { lng: 114.1715090751726, lat: 4.006152821794852 },
      { lng: 114.1708123032692, lat: 4.006982588126412 },
      { lng: 114.1708045321384, lat: 4.008499024997696 },
      { lng: 114.1713207257392, lat: 4.010899635594503 },
      { lng: 114.1719690488171, lat: 4.01266270052355 },
      { lng: 114.1705595876026, lat: 4.014321153848541 },
      { lng: 114.1699346193198, lat: 4.015667181831459 },
      { lng: 114.166558893469, lat: 4.019866232490083 },
      { lng: 114.1635735105678, lat: 4.022608220595778 },
      { lng: 114.1630246188664, lat: 4.023861324754434 },
      { lng: 114.1619550456725, lat: 4.025964864730895 },
      { lng: 114.1613818398808, lat: 4.028536026124511 },
      { lng: 114.1614337143692, lat: 4.029912475242841 },
      { lng: 114.1614948935386, lat: 4.030679572785494 },
      { lng: 114.1621065290597, lat: 4.031543692778367 },
      { lng: 114.1622724362143, lat: 4.032689389139239 },
      { lng: 114.162600677896, lat: 4.033835242546029 },
      { lng: 114.1622967645397, lat: 4.034670063353016 },
      { lng: 114.1594855048028, lat: 4.035054650143239 },
      { lng: 114.1583622295986, lat: 4.034023584963085 },
      { lng: 114.1562452829179, lat: 4.032713809586996 },
      { lng: 114.1546073567679, lat: 4.032704962903417 },
      { lng: 114.1537383672156, lat: 4.033155309022151 },
      { lng: 114.1526090353599, lat: 4.033621235360881 },
      { lng: 114.1516325583412, lat: 4.034632923660578 },
      { lng: 114.1502323687111, lat: 4.039284843661124 },
      { lng: 114.1496303921575, lat: 4.042299455018153 },
      { lng: 114.1488784297558, lat: 4.04322284494593 },
      { lng: 114.1488229294369, lat: 4.044224564540413 },
      { lng: 114.1484647337713, lat: 4.045620659352376 },
      { lng: 114.1484258491996, lat: 4.046936631714454 },
      { lng: 114.1489748092962, lat: 4.04806069791237 },
      { lng: 114.1505512220383, lat: 4.048700197505394 },
      { lng: 114.1512089144967, lat: 4.048922671632673 },
      { lng: 114.1522400427579, lat: 4.048660328135228 },
      { lng: 114.1532052856512, lat: 4.048585994637204 },
      { lng: 114.1540682093337, lat: 4.049044059270069 },
      { lng: 114.1549906754431, lat: 4.049243439155585 },
      { lng: 114.1562849223853, lat: 4.049256831438445 },
      { lng: 114.1569700739754, lat: 4.0500099498563 },
      { lng: 114.1567859299504, lat: 4.051319555233485 },
      { lng: 114.1548012522015, lat: 4.053734178955166 },
      { lng: 114.152825982194, lat: 4.054735580577452 },
      { lng: 114.1490843162993, lat: 4.054696907492285 },
      { lng: 114.1482121632789, lat: 4.055031705821322 },
      { lng: 114.1468545917203, lat: 4.05499647367191 },
      { lng: 114.1463795709935, lat: 4.055338622165886 },
      { lng: 114.1454374425604, lat: 4.055964943167106 },
      { lng: 114.1447710041698, lat: 4.056994028033273 },
      { lng: 114.1445471571063, lat: 4.057887972786083 },
      { lng: 114.144599532392, lat: 4.058832180649065 },
      { lng: 114.1450973699495, lat: 4.060095708774473 },       
    ],
  },  
];

export default dataProposeLayout;
